/**
 * Main component for free account signup page
 * @author Housefolios
 * @created 2021-09-16 13:21:50
 * @modified 2025-06-17 14:05:00
 * @modifiedBy David Helmick
 */

import React, { useState } from 'react'
import { Grid } from '@mui/material'

// Import shared hooks
import { useUrlParams } from '@/hooks/useUrlParams'
import { useSignupMutation } from '@/hooks/useSignupMutation'

// Import HOC
import withLoading from '../../Session/withLoading'

// Import components
import HeroSection from './HeroSection'
import SignupForm from './SignupForm'

function FreeAccountComponent({ setLoader  }) {
  const [email, setEmail] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [password, setPassword] = useState('')
  const [passwordMask, setPasswordMask] = useState(true)
  const [agree, setAgree] = useState(false)

  const { hfpid, refOrg, planID } = useUrlParams()

  const userInput = {
    profile: {
      firstname: firstName,
      lastname: lastName,
    },
    email: email.toLowerCase(),
    organization: firstName + lastName,
    phone: phoneNumber,
    stripePlanId: planID,
    password: password,
    referredByDetails: hfpid
      ? {
          affiliateId: hfpid,
          saleDate: new Date(),
          productSelected: 'free',
          productTotalPrice: 0,
          couponUsed: null,
          active: true,
        }
      : null,
    refOrg: refOrg || null,
  }

  const { checkSignup, signUp, signUpError } =
    useSignupMutation(userInput)

  const handleSubmit = async () => {
    setLoader(true)
    const productChoice = 'free'
    const planPrice = 0

    try {
      await checkSignup()
      const { data } = await signUp()

      localStorage.setItem('token', data.signUp.token)
      localStorage.setItem(`buyBox-${data.signUp.orgId}`, 'true')
      window.location.reload()
    } catch (error) {
      console.log('"' + error.message + '"')
      var errorElement = document.getElementById('card-errors')
      if (error && errorElement) {
        errorElement.textContent =
          error.message.slice(0, 21) === 'GraphQL error: Error:'
            ? error.message.slice(21)
            : null
      }
    } finally {
      setLoader(false)
    }
  }

  return (
    <Grid
      container
      direction="row"
      spacing={0}

      sx={{ minHeight: '100vh' }}
    >
      <Grid
        size={{
          md: 5,
          xl: 6,
        }}
        sx={{ display: 'flex' }}
      >
        <HeroSection />
      </Grid>
      <Grid
        size={{
          md: 7,
          xl: 6,
        }}
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <SignupForm
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          passwordMask={passwordMask}
          setPasswordMask={setPasswordMask}
          firstName={firstName}
          setFirstName={setFirstName}
          lastName={lastName}
          setLastName={setLastName}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          agree={agree}
          setAgree={setAgree}
          signUpError={signUpError}
          handleSubmit={handleSubmit}
        />
      </Grid>
    </Grid>
  )
}

export default withLoading(FreeAccountComponent)
